/** Local calendar date as YYYY-MM-DD (not UTC midnight). */
export function toLocalIsoDateString(date = new Date()) {
 const d = date instanceof Date ? date : new Date(date)
 if (isNaN(d.getTime())) return ""
 return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
}

/**
 * Whole calendar days from start date (inclusive of start as day 0) to today in local time.
 * Same calendar day => 0; next calendar day => 1; etc.
 */
export function getCalendarDaysElapsedSince(startIsoDate) {
 if (!startIsoDate) return 0
 const m = String(startIsoDate).trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
 if (!m) return 0
 const y = parseInt(m[1], 10)
 const mo = parseInt(m[2], 10) - 1
 const day = parseInt(m[3], 10)
 const start = new Date(y, mo, day)
 if (isNaN(start.getTime())) return 0
 const now = new Date()
 const end = new Date(now.getFullYear(), now.getMonth(), now.getDate())
 const diff = Math.round((end - start) / (1000 * 60 * 60 * 24))
 return Math.max(0, diff)
}

/** ISO-8601 instant → locale date + time, or em dash if missing. */
export function formatDateTimeFromIso(iso) {
 if (!iso) return "—"
 const d = new Date(iso)
 return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString()
}

export function formatDateToDDMMYY(input) {
 if (!input) return ""

// If input is already a Date object
 let d = input instanceof Date ? input : null

// Try native parsing first
 if (!d) {
 d = new Date(input)
 if (isNaN(d)) d = null
 }

// Fallback: try parsing mm/dd/yyyy (e.g., "3/26/2026")
 if (!d) {
 const mdy = String(input).trim().match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/)
 if (mdy) {
 const month = parseInt(mdy[1], 10)
 const day = parseInt(mdy[2], 10)
 let year = parseInt(mdy[3], 10)
 if (year < 100) year += 2000
 d = new Date(year, month - 1, day)
 }
 }

 if (!d || isNaN(d)) return String(input) // give up and return original

 const dd = String(d.getDate()).padStart(2, "0")
 const mm = String(d.getMonth() + 1).padStart(2, "0")
 const yy = String(d.getFullYear()).slice(-2)

 return `${dd}/${mm}/${yy}`
 }